import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";

interface Props {
  onTapCloseModal: () => void;
}

export const UpdateCompleteModal = ({ onTapCloseModal }: Props) => {
  const {
      openHomeModal,
    } = useModalContext();

    let title = "";
    let message = "";

    if (openHomeModal === "UserInfoComplete") {
      title = "ユーザー名変更完了";
      message = "ユーザー名の変更が完了しました。";
    }
    else if (openHomeModal === "UserPasswordComplete") {
      title = "パスワード変更完了";
      message = "パスワードの変更が完了しました。次回ログイン時から新しいパスワードが有効になります。";
    }
    else {
      title = "変更完了";
      message = "変更が完了しました。";
    }

  return (
    <BasePageModal
      title={title}
      handleClose={onTapCloseModal}
      bottomChildren={
        <BaseRoundButton
          buttonText="閉じる"
          onClick={onTapCloseModal}
        />
      }
    >
      <div className="update_complete_modal__content">
        <p className="update_complete_modal__message">{message}</p>
      </div>
    </BasePageModal>
  );
};
